var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"d-sr-only"},[_vm._v("[opens in a new tab]")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":_vm.color,"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.mdiOpenInNew))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }